var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.75098H7.5C7.36739 9.75098 7.24021 9.6983 7.14645 9.60453C7.05268 9.51076 7 9.38358 7 9.25098C7 9.11837 7.05268 8.99119 7.14645 8.89742C7.24021 8.80365 7.36739 8.75098 7.5 8.75098H8.75C8.88261 8.75098 9.00979 8.80365 9.10355 8.89742C9.19732 8.99119 9.25 9.11837 9.25 9.25098C9.25 9.38358 9.19732 9.51076 9.10355 9.60453C9.00979 9.6983 8.88261 9.75098 8.75 9.75098Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.25098H5.5C5.10218 9.25098 4.72064 9.09294 4.43934 8.81164C4.15804 8.53033 4 8.1488 4 7.75098V6.50098",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8.00098C3.25 8.00098 2.75 7.50098 2.75 6.87598V6.12598C2.75 5.50098 3.25 5.00098 4 5.00098",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.751V15.716C15.75 15.0536 15.5621 14.4048 15.2081 13.845C14.8541 13.2852 14.3485 12.8373 13.75 12.5535L11 11.251C10.2028 12.0452 9.12529 12.4942 8 12.501C6.825 12.501 6.0375 12.001 5.25 11.251L2.25 12.5535C1.65155 12.8373 1.14593 13.2852 0.791901 13.845C0.437869 14.4048 0.249958 15.0536 0.25 15.716V15.751",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 11.251L3.5 14.501L6 14.001",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.251L12.5 14.501L10 14.001",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00059 6.50059V4.25059C3.99145 3.72278 4.08867 3.19854 4.28645 2.70911C4.48423 2.21968 4.77853 1.77507 5.1518 1.4018C5.52507 1.02853 5.96968 0.734234 6.45911 0.536451C6.94854 0.338668 7.47278 0.241449 8.00059 0.25059C10.2781 0.25059 12.2506 2.00059 12.2506 4.25059V8.00059C12.2506 8.00059 12.0006 11.0006 13.2506 12.2506",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.5V7.375C11.25 9.095 9.845 11 8.125 11C6.405 11 5 9.095 5 7.375V5.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.50098H9.75V3.00098L8.5 4.50098H5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.2e1592c9.svg";
export { ForwardRef as ReactComponent };